import React from "react";
import { Link } from "react-router-dom";
import {
  FaCloudDownloadAlt,
  FaFacebookF,
  FaGoogle,
  FaShoppingBag,
  FaTwitter,
} from "react-icons/fa";

/** Shared B2B Hub home-page footer (reused across public pages). */
export default function HubHomeFooter() {
  return (
    <footer className="hub-home-footer">
      <div className="container-fluid hub-home-footer__inner">
        <div className="hub-home-footer__links-col">
          <h4>About</h4>
          <Link to="/about-us">About Us</Link>
          <Link to="/partner-with-us">Partner with us</Link>
          <Link to="/investor-relations" className="hub-home-footer__link--hidden">
            Investor Relations
          </Link>
          <Link to="/press-media" className="hub-home-footer__link--hidden">
            Press & Media
          </Link>
          <Link to="/contact">Contact Us</Link>
          <button type="button" id="hub-download-app" className="hub-home-footer__download">
            <FaCloudDownloadAlt aria-hidden />
            Download App
          </button>
          <div className="hub-home-footer__social" aria-label="Social links">
            <Link to="/" aria-label="Google">
              <FaGoogle aria-hidden />
            </Link>
            <Link to="/" aria-label="Facebook">
              <FaFacebookF aria-hidden />
            </Link>
            <Link to="/" aria-label="Twitter">
              <FaTwitter aria-hidden />
            </Link>
            <Link to="/" aria-label="Shopping">
              <FaShoppingBag aria-hidden />
            </Link>
          </div>
        </div>
        <div className="hub-home-footer__links-col">
          <h4>For Buyers</h4>
          <Link to="/marketplace/products">Browse Products</Link>
          <Link to="/buyer-rfq-form">RFQ</Link>
          <Link to="/marketplace/products?verifiedOnly=1">Verified Suppliers</Link>
        </div>
        <div className="hub-home-footer__links-col">
          <h4>For suppliers</h4>
          <Link to="/signup?tradeRole=Seller">Sell on Platform</Link>
          <Link to="/contact?enquiry=supplier" className="hub-home-footer__link--hidden">
            Supplier Membership Plans
          </Link>
          <Link to="/contact?enquiry=advertising" className="hub-home-footer__link--hidden">
            Advertising Solutions
          </Link>
        </div>
        <div className="hub-home-footer__links-col">
          <h4>Customer Services</h4>
          <Link to="/help-center">Help Center</Link>
          <Link to="/help-center/raise-ticket">Raise Ticket</Link>
          <Link to="/help-center/feedback">Feedback</Link>
          <Link to="/submit-dispute">Submit a Dispute</Link>
          <Link to="/faq">FAQ</Link>
        </div>
        <div className="hub-home-footer__links-col">
          <h4>Trade Services</h4>
          <Link to="/logistics-providers">Logistics</Link>
          <Link to="/legal-experts" className="hub-home-footer__link--hidden">
            Hire Legal Experts
          </Link>
          <Link to="/consultants" className="hub-home-footer__link--hidden">
            Hire Consultants
          </Link>
          <Link to="/inspection-services" className="hub-home-footer__link--hidden">
            Inspection Services
          </Link>
        </div>
        <div className="hub-home-footer__links-col">
          <h4>Policies & Legal</h4>
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/refund-cancellation-policy">Refund &amp; Cancellation Policy</Link>
          <Link to="/domain-redirection-policy">Domain Redirection Policy</Link>
          <Link to="/cookies" className="hub-home-footer__link--hidden">
            Cookie Policy
          </Link>
          <Link to="/terms-and-conditions?module=AUCTION">Auction T&C</Link>
        </div>
      </div>
      <div className="hub-home-footer__bar">
        <span>© {new Date().getFullYear()} Trocanet. All rights reserved.</span>
      </div>
    </footer>
  );
}
